import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DLPGuard } from "@/lib/dlp";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import RestrictedAccess from "@/pages/RestrictedAccess";
import Home from "@/pages/Home";
import People from "@/pages/People";
import OrgChart from "@/pages/OrgChart";
import Courts from "@/pages/Courts";
import CourtDetail from "@/pages/CourtDetail";
import Vendors from "@/pages/Vendors";
import PracticeGroups from "@/pages/PracticeGroups";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Calendar from "@/pages/Calendar";
import Gallery from "@/pages/Gallery";
import ModulePage from "@/pages/ModulePage";
import Documents from "@/pages/Documents";
import Admin from "@/pages/Admin";
import MatterLifecycle from "@/pages/MatterLifecycle";
import TimeClock from "@/pages/TimeClock";
import MyTasks from "@/pages/MyTasks";
import Ethics from "@/pages/Ethics";
import Tickets from "@/pages/Tickets";

function Gate({ children }) {
  const { blocked } = useAuth();
  if (blocked) return <RestrictedAccess />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Gate>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <DLPGuard />
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Home />} />
              <Route path="/people" element={<People />} />
              <Route path="/org-chart" element={<OrgChart />} />
              <Route path="/courts" element={<Courts />} />
              <Route path="/courts/:id" element={<CourtDetail />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/practice-groups" element={<PracticeGroups />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/brief-bank" element={<Documents category="brief-bank" title="Precedent & Brief Bank" subtitle="Motions, pleadings, demand letters, discovery & settlement templates" />} />
              <Route path="/forms" element={<Documents category="brand-forms" title="Brand & Forms" subtitle="Letterhead, pleading paper, signature blocks & firm forms" />} />
              <Route path="/matter" element={<MatterLifecycle />} />
              <Route path="/my-tasks" element={<MyTasks />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/time" element={<TimeClock />} />
              <Route path="/billing" element={<ModulePage section="billing" title="Billing & Trust" subtitle="Time narratives, task codes, write-offs & IOLTA reconciliation" icon="receipt" />} />
              <Route path="/ethics" element={<Ethics />} />
              <Route path="/it" element={<ModulePage section="it" title="IT & Security" subtitle="MFA, VPN, printing, phishing & incident response" icon="server" />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </Gate>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
